import React from 'react';
import { Grid } from '@material-ui/core';
import Lottie from 'react-lottie';
import loadingAnimation from 'assets/loading.json';

import { Container, useStyles, LoadingWrapper } from './styles';

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingAnimation,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export const LoadingPage = () => {
  const classes = useStyles();
  return (
    <Container>
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        className={classes.root}
      >
        <Grid item>
          <LoadingWrapper>
            <Lottie options={defaultOptions} height={180} width={180} />
          </LoadingWrapper>
        </Grid>
      </Grid>
    </Container>
  );
};

export const LoadingComponent = ({ width = '150px', height = '150px' }) => {
  return (
    <LoadingWrapper style={{ width, height }}>
      <Lottie options={defaultOptions} height={height} width={width} />
    </LoadingWrapper>
  );
};
